"use strict";

require("core-js/modules/es.object.define-property.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
Object.defineProperty(exports, "validations", {
  enumerable: true,
  get: function get() {
    return _validations["default"];
  }
});
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _GAD = _interopRequireDefault(require("../GAD7"));
var _adverseModal = _interopRequireDefault(require("./adverseModal"));
var _styledReactModal = require("styled-react-modal");
var _validations = _interopRequireDefault(require("./validations"));
var defaultModalHeader = "Mental Health Resources";
var defaultModalContent = /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("p", null, "If this in an emergency please call ", /*#__PURE__*/_react["default"].createElement("b", null, "911"), "."), /*#__PURE__*/_react["default"].createElement("p", null, "If this is not an emergency but you are experiencing thoughts of suicide and need to speak with a counselor, please contact the National Suicide Prevention Lifeline at ", /*#__PURE__*/_react["default"].createElement("b", null, "1-800-273-8255"), ". They also have a chat feature if you are not able to get through via telephone. Their website is", ' ', /*#__PURE__*/_react["default"].createElement("a", {
  href: "http://suicidepreventionlifeline.org/",
  target: "_blank"
}, "http://suicidepreventionlifeline.org/"), ". This is service provides 24/7, free confidential support for people in distress, providing resources for you and your loved ones about prevention and crisis."), /*#__PURE__*/_react["default"].createElement("p", null, "Thank you, ", /*#__PURE__*/_react["default"].createElement("br", null), " Achievement Studies"));
var PHQ9 = function PHQ9(props) {
  var _props$config = props.config,
    displayMessage = _props$config.displayMessage,
    remoteSubmit = _props$config.remoteSubmit,
    submitting = props.meta.submitting;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_GAD["default"], props), /*#__PURE__*/_react["default"].createElement(_styledReactModal.ModalProvider, null, /*#__PURE__*/_react["default"].createElement(_adverseModal["default"], {
    isOpen: displayMessage,
    header: props.modal_header || defaultModalHeader,
    content: props.modal_content || defaultModalContent,
    submitting: submitting,
    remoteSubmit: remoteSubmit
  })));
};
PHQ9.defaultProps = {
  questions: ['Little interest or pleasure in doing things', 'Feeling down, depressed or hopeless', 'Trouble falling asleep, staying asleep, or sleeping too much', 'Feeling tired or having little energy', 'Poor appetite or overeating', 'Feeling bad about yourself - or that you are a failure or have let yourself or your family down', 'Trouble concentrating on things, such as reading the newspaper or watching television', 'Moving or speaking so slowly that other people could have noticed? Or, the opposite - being so fidgety or restless that you have been moving around a lot more than usual', 'Thoughts that you would be better off dead, or of hurting yourself'],
  answer_labels: ['Not at all', 'Several days', 'More than half the days', 'Nearly every day']
};
PHQ9.propTypes = {
  input: _propTypes["default"].shape({
    onChange: _propTypes["default"].func.isRequired,
    onBlur: _propTypes["default"].func,
    onFocus: _propTypes["default"].func
  })
};
var _default = exports["default"] = PHQ9;